import type { ConsentedPolicyKey, PolicyMetaData } from "@/core/types";

type PolicyVersionProps = {
  policy: ConsentedPolicyKey;
  policyMetadata: PolicyMetaData;
};

export function getCurrentPolicyVersion({ policy, policyMetadata }: PolicyVersionProps) {
  return policyMetadata?.[policy]?.current_version;
}
